interface FontStyle {
  size?: string;
  family?: string;
  weight?: string;
  style?: string;
}

// Create a single canvas context to reuse
const canvas = document.createElement('canvas');
const context = canvas.getContext('2d');

/**
 * Calculates the width of a piece of text using a canvas context.
 * This is a non-hook utility function.
 * @param text The text to measure.
 * @param font The font styles to apply.
 * @returns The width of the text in pixels.
 */
export const getTextWidth = (text: string, font: FontStyle): number => {
  if (!context) {
    // Canvas not supported, return a fallback
    return 0;
  }

  const { size = '16px', family = 'sans-serif', weight = 'normal', style = 'normal' } = font;
  context.font = `${style} ${weight} ${size} ${family}`;

  return context.measureText(text).width;
};